export default `STATE,2016
Abia,3727347
Adamawa,4248436
Akwa Ibom,5482177
Anambra,5527809
Bauchi,6537314
Bayelsa,2277961
Benue,5741815
Borno,5860183
Cross River,3866269
Delta,5663362
Ebonyi,2880383
Edo,4235595
Ekiti,3270798
Enugu,4411119
Federal Capital Territory,3564126
Gombe,3256962
Imo,5408756
Jigawa,5828163
Kaduna,8252366
Kano,13076892
Katsina,7831319
Kebbi,4440050
Kogi,4473490
Kwara,3192893
Lagos,12550598
Nasarawa,2523395
Niger,5556247
Ogun,5217716
Ondo,4671695
Osun,4705589
Oyo,7840864
Plateau,4200442
Rivers,7303924
Sokoto,4998090
Taraba,3066834
Yobe,3294137
Zamfara,4515427`